const currencyList = {
  '$': {
    code: 'USD',
    locale: 'en-US',
  }
};

/**
 * @param {string|number} price
 * @param {string|null} currencySymbol
 * @returns {string}
 */
const formatPrice = (price, currencySymbol = null) => {
  // Price in cents
  if (typeof price === 'number') {
   price = +(price / 100).toFixed(2)
  }

  currencySymbol = currencySymbol ?? localStorage.getItem('currency');

  return getCurrencyFormatter(currencySymbol).format(price).replace(/\s/g, '');
};

/**
 * @param {string} currencySymbol
 * @returns {Intl.NumberFormat}
 */
const getCurrencyFormatter = (currencySymbol) => {
  const options = {
    style: 'currency',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  };

  if (!(currencySymbol in currencyList)) {
    currencySymbol = '$';
  }

  options.currency = currencyList[currencySymbol].code;

  return new Intl.NumberFormat(currencyList[currencySymbol].locale, options);
};
